import { isPlatformBrowser } from '@angular/common';
import {
  Inject,
  Injectable,
  NgZone,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2
} from '@angular/core';
import { ToastrService as TS } from 'ngx-toastr';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private renderer: Renderer2;
  constructor(
    private readonly ts: TS,
    private readonly router: Router,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * @description show success toaster
   * @param msg toast message
   */
  showSuccess(msg: string) {
    this.showToast('success', msg);
  }

  /**
   * @description show error toaster
   * @param msg toast message
   */
  showError(msg: string) {
    this.showToast('error', msg);
  }

  /**
   * @description show warning toaster
   * @param msg toast message
   */
  showWarning(msg: string) {
    this.showToast('warning', msg);
  }

  /**
   * @description show Info toaster
   * @param msg toast message
   */
  showInfo(msg: string) {
    this.showToast('info', msg);
  }

  /**
   * @description clear toaster
   */
  clear() {
    this.ts.clear();
  }

  showToast(type: 'success' | 'error' | 'warning' | 'info', msg: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    setTimeout(() => {
      this.ts[type](msg, '', {
        toastClass: 'ngx-toastr custom-toast'
      });
      if (type === 'success' || type === 'error' || type === 'warning') {
        setTimeout(() => {
          if (isPlatformBrowser(this.platformId)) {
            const child = document.querySelector(`.toast-${type}`);
            if (child) {
              const className =
                type === 'success'
                  ? 'success-span'
                  : type === 'error'
                    ? 'error-span'
                    : 'warning-span';
            
              const existingSpan = Array.from(child.children).find(
                (el: any) => el.tagName === 'SPAN' && el.classList.contains(className)
              );
              if (!existingSpan) {
                const span = this.renderer.createElement('span');
                this.renderer.addClass(span, className);
                this.renderer.appendChild(child, span);
              }
            }
          }
        }, 150);
      }
    }, 100);
  }

  showActivityNotificationToast(msg: string, url: any, wlsIcon: string = '') {
    this.zone.run(() => {
      this.ts.show('', '', {
        toastClass: 'ngx-firebase-toastr firebase-custom-toast'
      });
      if (isPlatformBrowser(this.platformId)) {
        const observer = new MutationObserver(() => {
          const toastContainer = document.querySelector(
            '.ngx-firebase-toastr.firebase-custom-toast'
          );

          if (toastContainer) {
            const contentWrapper = this.renderer.createElement('div');
            this.renderer.addClass(contentWrapper, 'toast-content-wrapper');
            this.renderer.listen(contentWrapper, 'click', () => {
              this.navigateWithoutBaseUrl(url);
            });
            const img = this.renderer.createElement('img');
            this.renderer.setAttribute(
              img,
              'src',
              wlsIcon || './../../../../assets/images/svg/topfan-circular.svg'
            );
            this.renderer.setAttribute(img, 'alt', 'icon');
            this.renderer.addClass(img, 'toast-icon');
            this.renderer.appendChild(contentWrapper, img);

            const textContainer = this.renderer.createElement('div');
            this.renderer.addClass(textContainer, 'toast-text-container');
            const message = this.renderer.createElement('span');
            this.renderer.addClass(message, 'firebase-toast-message');
            this.renderer.appendChild(message, this.renderer.createText(msg));
            this.renderer.appendChild(textContainer, message);
            this.renderer.appendChild(contentWrapper, textContainer);
            this.renderer.appendChild(toastContainer, contentWrapper);
            observer.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
  }
  navigateWithoutBaseUrl(fullUrl: string) {
    const url = new URL(fullUrl);
    const path = url.pathname;

    const queryParams = {};
    url.searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });
    this.router.navigate([path], { queryParams });
  }
}
